import { Navigate } from 'react-router-dom';
import { useAcl } from '@/hooks/useAcl';
import { getRoleHomeRoute } from '@/router/roleRoutes';

/** Sends /dashboard to whichever dashboard the active role owns. */
export default function RoleHomeRedirect() {
  const { role } = useAcl();
  return <Navigate to={getRoleHomeRoute(role)} replace />;
}
